<!-- 图片滑动组件：一屏单元素+定时切换+按钮控制 -->
<template>
<div class="content-block">
  <div class="info-list-title" v-if="showTitle" style="margin-bottom: 0px;">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <router-link v-if="showMore" :to="{path:moreLink}">更多</router-link>
  </div>
  <div class="info-list-act" v-if="showAct">
    <a class="list-act-bt01"></a>
  </div>
  <div class="info-list-content" >
    <div class="no-record" v-if="infoList.length<1">暂无数据</div>
    <div class="img-slide-warp" :style="{'height': warpHeight}" @mouseenter="enter()" @mouseleave="leave()"  v-if="infoList.length>0">
      <transition-group :name="currentDirection" tag="ul" class="ac_scroll-ul">
        <li v-for="(info,index) in infoList" :key="index" v-show="currentIndex===(index+1)" class="ac_scroll-item">
            <component  :is="infoBlock" :info="info" :titleLength="titleLength"/></component>
        </li>
      </transition-group>
      <div class="item-order">
            <span v-for="(info,index) in infoList":key="index" v-bind:class="['item-order-item',currentIndex===(index+1)?'item-act':'']" ></span>
      </div>
      <a v-if="showHandle" v-bind:class="['button-left',themStyleSet[btStyle]]" @click="handlePre()">&#139</a>
      <a v-if="showHandle" v-bind:class="['button-right',themStyleSet[btStyle]]" @click="handleNext()">&#155</a>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'ImageSlide01',
  components:{},
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    showMore: {
      type: Boolean,
      default: false
    },
    moreLink:{
      type: String,
      default: '/'
    },
    showAct: {
      type: Boolean,
      default: false
    },
    showHandle: {
      type: Boolean,
      default: false
    },
    isAutoPlay:{
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: Number,
      default: 16
    },
    label: {
      type: String,
      default: ''
    },
    warpH:{
      type: String,
      default: '160px'
    },
    col: {
      type: String,
      default: '3'
    },
    count: {
      type: String,
      default: '3'
    },
    colPadding: {
      type: String,
      default: '30'
    },
    btStyle:{
      type:String,
      default:'0'
    },
    infoBlock:{
      type:Object,
      default:function(){return {}}
    },
    infoList:{
      type:Array,
      default:function(){return []}
    }
  },
  data() {
    return {
      warpHeight:this.warpH,
      celWidth: "calc(100%/" + this.col + ")",
      currentIndex:1,
      currentDirection:"left",
      themStyleSet:['btn-them-1','btn-them-2'],
      initParms:{},
      timer:{},
    }
  },
  computed: {

  },
  mounted(){
    this.autoPlay();
  },
  created:function(){
    //this.infoList=this.Global.newsListDemo.slice(0,this.count);
    this.queryPage({page:1,pageSize:this.count,title:this.title});
  },
  methods: {
    queryPage:function(params){
      this.initParms=params;
      this.$emit("queryPage",this.initParms);
    },
    handlePre(){
      this.currentIndex--;
      if(this.currentIndex==0){
        //console.log("图片滑动--右移动!--重置index="+this.count);
        this.currentIndex=this.infoList.length;
      };
      this.currentDirection="right";
      //console.log("图片滑动--右移动!--index="+this.currentIndex);
    },
    handleNext(){
      this.currentIndex++;
      if(this.currentIndex>this.infoList.length){
        //console.log("图片滑动--左移动!--重置index="+this.totalPage);
        this.currentIndex=1;
      };
      this.currentDirection="left";
      //console.log("图片滑动--左移动!--index="+this.currentIndex);
    },

    autoPlay(){
      if(this.isAutoPlay){
        this.timer=setInterval(this.handleNext,3000);
      }
    },
    leave(){
      //console.log("鼠标离开!");
      //this.handleNext();
      this.autoPlay();
    },
    enter(){
      //console.log("鼠标进入!");
      clearInterval(this.timer);
    }

  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-slide-warp{
  position:relative;
  //background:yellow;
}
ul {
  display:block;
  position:relative;
  box-sizing:content-box;
  width:100%;
  height:100%;
  list-style-type: none;
  padding:0px 0px 10px 0px;
  //background:red;
  overflow:hidden;
}

li {
  position:absolute;
  float:left;
  margin: 0px 0px 0px 0px;
  padding:0px;
  height:100%;
  width:100%;
  text-align:left;
  //background:green;
  background-size: auto 300px;
  background-repeat: no-repeat;
  background-position:center center;
}

.item-order{
  position:absolute;
  display: flex;
  flex-wrap: wrap;
  justify-content:center;
  bottom:-4px;
  padding:0px;
  height:2px;
  width:100%;
  text-align:center;
  //background:green;
}

.item-order-item{
  height:2px;
  width:10px;
  margin:0px 2px 0 2px;
  background-color: rgba(0, 0, 0, 0.5);
}

.item-act{
  background-color: #fff;
}

.cell-left{
  padding-left:0px;
  padding-right:10px;
}
.cell-right{
  padding-left:10px;
  padding-right:0px;
}
.cell-center{
  padding-left:5px;
  padding-right:5px;
}

.list-act-bt01{
  display:block;
  float:left;
  height:30px;
  width:100px;
  padding:0px;
  margin:15px 15px 15px 0px;
  background:var(--color6);
  font-size:12px;
  line-height:30px;
  text-align:center;
  color:#fff;
  cursor: pointer;
  border-radius:15px;
}

.ac_scroll-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content:left;
}

.ac_scroll-cell {
  position:relative;
  box-sizing: border-box;
  height: 100%;
  background: #red;
  border: 0px solid red;
}

.button-left{
  display:block;
  position:absolute;
  left:-50px;
  top: calc(50% - 15px);

}
.button-right{
  display:block;
  position:absolute;
  right:-50px;
  top: calc(50% - 15px);
}

.btn-them-1{
    background:#8a8a8a;
    color: #ffffff;
    height:30px;
    width:30px;
    cursor: pointer;
    font-size: 30px;
    line-height:25px;
    border-radius:15px;
}

.btn-them-2{
    color: #515151;
    height:30px;
    width:30px;
    cursor: pointer;
    font-size: 50px;
    line-height:25px;
}

/** 滚动动画 */
.left-enter {
    transform: translateX(100%) translateY(0);
}

.left-enter-to {
    transition: all 1s ease;
    transform: translateX(0) translateY(0);
}

.left-leave {
    transform: translateX(0) translateY(0);
}

.left-leave-active {
    transition: all 1s ease;
    transform: translateX(-100%)
}


.right-enter {
    transform: translateX(-100%) translateY(0);
}

.right-enter-to {
    transition: all 1s ease;
    transform: translateX(0) translateY(0);
}

.right-leave {
    transform: translateX(0) translateY(0);
}

.right-leave-active {
    transition: all 1s ease;
    transform: translateX(100%)
}

</style>



// WEBPACK FOOTER //
// src/components/block/ImageSlide01.vue